const getUsersById = state => state.users.byId;

export default getUsersById;